export const APP_CONFIG_STATIC_RESOURCE_HOST_DEFAULT = 'https://static.shoplineapp.com/';
